import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./Components/app/App";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <BrowserRouter basename='/DevPrep-FE'>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </BrowserRouter>
);
